
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personnel/[id]",
      function () {
        return require("private-next-pages/personnel/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personnel/[id]"])
      });
    }
  